import * as types from '../../mutationTypes';

export default {
    /* eslint-disable no-param-reassign */
    [types.SET_VERSION](state, value) {
        state.version = value;
    },

    [types.SET_API_VERSION](state, value) {
        state.apiVersion = value;
    },
    [types.SET_CE_VERSION](state, value) {
        state.ceVersion = value;
    },

    [types.SET_INITIALISED](state) {
        state.initialised = true;
    },

    [types.SET_SEARCH_TEXT](state, value) {
        state.searchText = value;
    }
    /* eslint-enable no-param-reassign */
};



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js